import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row no-wrap" }

import { PropType, computed, defineComponent } from 'vue';

import SIcon from 'SharedComponents/ui/Icon/SIcon.vue';
import { DELAY_TOOLTIP } from 'SharedDir/constants/common';
import { CertificateInfo } from 'SharedDir/declarations/crypto-pro';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'Certificate',
},
  __name: 'Certificate',
  props: {
    cert: {},
    tooltip: {},
    active: { type: Boolean },
    ribbon: { type: Boolean }
  },
  setup(__props: any) {



const props = __props;

const commonName = computed(() => {
  const { subjectName } = props.cert;
  const match = subjectName.match(/CN=([^,]+)/);
  if (match && match[1]) {
    return match[1].trim(); // Возвращаем найденное значение
  }
  return subjectName; // Если не найдено
});

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, {
    class: _normalizeClass(["border-radius non-selectable", {
      'bg-brand-secondary': _ctx.active,
      'text-white': _ctx.active,
    }]),
    clickable: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.ribbon)
              ? (_openBlock(), _createBlock(SIcon, {
                  key: 0,
                  name: "custom:files/signed",
                  class: "small-margin-right"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_item_label, {
              class: "text-h7 base-margin-bottom",
              lines: "5"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(commonName.value), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_q_item_label, { lines: "2" }, {
            default: _withCtx(() => [
              _createTextVNode(" Выдан: " + _toDisplayString(_ctx.cert.issuerName) + ". ", 1),
              _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" Действителен с " + _toDisplayString(_ctx.cert.validFrom.toLocaleString()) + " по " + _toDisplayString(_ctx.cert.validTo.toLocaleString()) + ". ", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.tooltip)
        ? (_openBlock(), _createBlock(_component_q_tooltip, {
            key: 0,
            "content-class": "s-tooltip",
            delay: _unref(DELAY_TOOLTIP)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.tooltip), 1)
            ]),
            _: 1
          }, 8, ["delay"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})